export const getRealmName = (): string => {
  const externalPaths = ['forgot-password', 'terms', 'privacy-policy'];
  const paths: string[] = location.href.split('/');
  return (paths && !externalPaths.includes(paths[4]) && paths[4]) || '';
};

export const getAppBaseHref = () => `/${getRealmName()}`;

export const cleanMaskedAccountNumber = (maskedAccountNumber: string | undefined): string => {
  if (!maskedAccountNumber) {
    return '';
  }
  return maskedAccountNumber.replace(/[\s*]/g, '');
};
